import { render, staticRenderFns } from "./HintsPaywallModalContent.vue?vue&type=template&id=50b22878&scoped=true"
import script from "./HintsPaywallModalContent.vue?vue&type=script&lang=js"
export * from "./HintsPaywallModalContent.vue?vue&type=script&lang=js"
import style0 from "./HintsPaywallModalContent.vue?vue&type=style&index=0&id=50b22878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b22878",
  null
  
)

export default component.exports